import { ReferentialKey } from 'api/referential';
import { useAppDispatch } from 'app/hooks';
import { GenericViewHeader } from 'back-office/shared/components/GenericViewHeader';
import { SimpleDashboardContent } from 'features/dashboard/DashboardContent';
import { getMultipleReferentialsByKeys } from 'features/referentials/slices/getMultipleReferentialsByKeysThunk';
import { Building } from 'lucide-react';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

export default function PersonnesMoralesView() {
  const dispatch = useAppDispatch();

  // Référentiels des formulaires de création (courtier, compagnie,
  // gestionnaire, MIA) ouverts depuis le modal "Ajouter une personne morale".
  useEffect(() => {
    dispatch(getMultipleReferentialsByKeys([
      ReferentialKey.Plateforme,
    ]));
  }, [dispatch]);

  return (
    <SimpleDashboardContent>
      <GenericViewHeader
        title="Personnes morales"
        icon={Building}
      />
      <Outlet />
    </SimpleDashboardContent>
  );
}
